import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get, post } from "sr/utils/axios";

export const getCheckrPackage = async (planName) => {
  try {
    return await get<ApiResponse<[]>>(`/checkr/package/${planName}`).then((res) => {
      return res;
    });
  } catch (e) {
    HandleApiError(e);
  }
};
